<template>
	<div class="ap-wrap-site">
		<img :src="require(`@/assets/Logo.png`)" alt="Logo of the bwHealthApp" @click="toHome" />
		<h1 v-html="translations.apTitle"></h1>
		<div class="ap-wrap-content">
			<div>
				<h2 v-html="translations.apPreambleTitle"></h2>
			</div>
			<p v-html="translations.apPreambleText1"></p>
			<p v-html="translations.apPreambleText2"></p>
			<p v-html="translations.apPreambleText3"></p>

			<p v-html="translations.apPreambleText4"></p>
			<p v-html="translations.apPreambleText5"></p>

			<h2 v-html="translations.apDataProcessingTitle"></h2>
			<p v-html="translations.apDataProcessingText1"></p>

			<h3 v-html="translations.apDataProcessingDownloadTitle"></h3>
			<p v-html="translations.apDataProcessingDownloadText1"></p>

			<h3 v-html="translations.apDataProcessingAutomaticTitle"></h3>
			<p v-html="translations.apDataProcessingAutomaticText1"></p>

			<p style="text-decoration: underline;" v-html="translations.apDataProcessingAutomaticSub1Title"></p>
			<p v-html="translations.apDataProcessingAutomaticSub1Text"></p>
			<p style="text-decoration: underline;" v-html="translations.apDataProcessingAutomaticSub2Title"></p>
			<p v-html="translations.apDataProcessingAutomaticSub2Text"></p>
			<p style="text-decoration: underline;" v-html="translations.apDataProcessingAutomaticSub3Title"></p>
			<p v-html="translations.apDataProcessingAutomaticSub3Text"></p>
			<p style="text-decoration: underline;" v-html="translations.apDataProcessingAutomaticSub4Title"></p>
			<p v-html="translations.apDataProcessingAutomaticSub4Text"></p>
			<p style="text-decoration: underline;" v-html="translations.apDataProcessingAutomaticSub5Title"></p>
			<p v-html="translations.apDataProcessingAutomaticSub5Text"></p>
			<p style="text-decoration: underline;" v-html="translations.apDataProcessingAutomaticSub6Title"></p>
			<p v-html="translations.apDataProcessingAutomaticSub6Text"></p>

			<p v-html="translations.apDataProcessingAutomaticText2"></p>
			<p v-html="translations.apDataProcessingAutomaticText3"></p>

			<h3 v-html="translations.apDataProcessingAccountTitle"></h3>
			<p v-html="translations.apDataProcessingAccountText1"></p>

			<p v-html="translations.apDataProcessingAccountText2"></p>

			<h3 v-html="translations.apDataProcessingAppTitle"></h3>
			<p v-html="translations.apDataProcessingAppText1"></p>
			<ol>
				<li v-html="translations.apDataProcessingAppList1"></li>
				<li v-html="translations.apDataProcessingAppList2"></li>
				<li v-html="translations.apDataProcessingAppList3"></li>
				<li v-html="translations.apDataProcessingAppList4"></li>
			</ol>
			<p v-html="translations.apDataProcessingAppText2"></p>
			<p v-html="translations.apDataProcessingAppText3"></p>

			<h2 v-html="translations.apDataTransferTitle"></h2>

			<p v-html="translations.apDataTransferText1"></p>
			<h3 v-html="translations.apDataTransferRegistrationTitle"></h3>

			<p v-html="translations.apDataTransferRegistrationText1"></p>
			<p v-html="translations.apDataTransferRegistrationText2"></p>

			<h3 v-html="translations.apDataTransferAuthoritiesTitle"></h3>
			<p v-html="translations.apDataTransferAuthoritiesText1"></p>
			<p v-html="translations.apDataTransferAuthoritiesText2"></p>
			<ol>
				<li v-html="translations.apDataTransferAuthoritiesList1"></li>
				<li v-html="translations.apDataTransferAuthoritiesList2"></li>
			</ol>

			<h3 v-html="translations.apDataTransferDependenciesTitle"></h3>
			<p v-html="translations.apDataTransferDependenciesText1"></p>

			<h2 v-html="translations.apThirdCountriesTitle"></h2>

			<p v-html="translations.apThirdCountriesText1"></p>

			<h2 v-html="translations.apChangeOfPurposeTitle"></h2>
			<p v-html="translations.apChangeOfPurposeText1"></p>

			<h2 v-html="translations.apDataStoragePeriodTitle"></h2>
			<p v-html="translations.apDataStoragePeriodText1"></p>
			<h2 v-html="translations.apYourRightsTitle"></h2>

			<h3 v-html="translations.apYourRightsInformationTitle"></h3>
			<p v-html="translations.apYourRightsInformationText1"></p>
			<h3 v-html="translations.apYourRightsCorrectionTitle"></h3>
			<p v-html="translations.apYourRightsCorrectionText1"></p>

			<h3 v-html="translations.apYourRightsDeletionTitle"></h3>
			<p v-html="translations.apYourRightsDeletionText1"></p>

			<h3 v-html="translations.apYourRightsRestrictionTitle"></h3>
			<p v-html="translations.apYourRightsRestrictionText1"></p>
			<h3 v-html="translations.apYourRightsPortabilityTitle"></h3>
			<p v-html="translations.apYourRightsPortabilityText1"></p>

			<h2 v-html="translations.apObjectionTitle"></h2>
			<p v-html="translations.apObjectionText1"></p>

			<h2 v-html="translations.apAppealTitle"></h2>
			<p v-html="translations.apAppealText1"></p>
			<p v-html="translations.apAppealText2"></p>

			<h2 v-html="translations.apContactTitle"></h2>
			<p v-html="translations.apContactText1"></p>
			<p v-html="translations.apContactText2"></p>

			<p v-html="translations.apContactText3"></p>
			<h2 v-html="translations.apChangesTitle"></h2>
			<p v-html="translations.apChangesText1"></p>
		</div>
	</div>
</template>

<script>
import i18n from '@/translations/i18n';
export default {
	name: 'AppPrivacy',
	created() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	},
	data() {
		return {
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				apTitle: this.$t('apTitle'),
				apPreambleTitle: this.$t('apPreambleTitle'),
				apPreambleText1: this.$t('apPreambleText1'),
				apPreambleText2: this.$t('apPreambleText2'),
				apPreambleText3: this.$t('apPreambleText3'),
				apPreambleText4: this.$t('apPreambleText4'),
				apPreambleText5: this.$t('apPreambleText5'),
				apDataProcessingTitle: this.$t('apDataProcessingTitle'),
				apDataProcessingText1: this.$t('apDataProcessingText1'),
				apDataProcessingDownloadTitle: this.$t('apDataProcessingDownloadTitle'),
				apDataProcessingDownloadText1: this.$t('apDataProcessingDownloadText1'),
				apDataProcessingAutomaticTitle: this.$t('apDataProcessingAutomaticTitle'),
				apDataProcessingAutomaticText1: this.$t('apDataProcessingAutomaticText1'),
				apDataProcessingAutomaticSub1Title: this.$t('apDataProcessingAutomaticSub1Title'),
				apDataProcessingAutomaticSub1Text: this.$t('apDataProcessingAutomaticSub1Text'),
				apDataProcessingAutomaticSub2Title: this.$t('apDataProcessingAutomaticSub2Title'),
				apDataProcessingAutomaticSub2Text: this.$t('apDataProcessingAutomaticSub2Text'),
				apDataProcessingAutomaticSub3Title: this.$t('apDataProcessingAutomaticSub3Title'),
				apDataProcessingAutomaticSub3Text: this.$t('apDataProcessingAutomaticSub3Text'),
				apDataProcessingAutomaticSub4Title: this.$t('apDataProcessingAutomaticSub4Title'),
				apDataProcessingAutomaticSub4Text: this.$t('apDataProcessingAutomaticSub4Text'),
				apDataProcessingAutomaticSub5Title: this.$t('apDataProcessingAutomaticSub5Title'),
				apDataProcessingAutomaticSub5Text: this.$t('apDataProcessingAutomaticSub5Text'),
				apDataProcessingAutomaticSub6Title: this.$t('apDataProcessingAutomaticSub6Title'),
				apDataProcessingAutomaticSub6Text: this.$t('apDataProcessingAutomaticSub6Text'),
				apDataProcessingAutomaticText2: this.$t('apDataProcessingAutomaticText2'),
				apDataProcessingAutomaticText3: this.$t('apDataProcessingAutomaticText3'),
				apDataProcessingAccountTitle: this.$t('apDataProcessingAccountTitle'),
				apDataProcessingAccountText1: this.$t('apDataProcessingAccountText1'),
				apDataProcessingAccountText2: this.$t('apDataProcessingAccountText2'),
				apDataProcessingAppTitle: this.$t('apDataProcessingAppTitle'),
				apDataProcessingAppText1: this.$t('apDataProcessingAppText1'),
				apDataProcessingAppList1: this.$t('apDataProcessingAppList1'),
				apDataProcessingAppList2: this.$t('apDataProcessingAppList2'),
				apDataProcessingAppList3: this.$t('apDataProcessingAppList3'),
				apDataProcessingAppList4: this.$t('apDataProcessingAppList4'),
				apDataProcessingAppText2: this.$t('apDataProcessingAppText2'),
				apDataProcessingAppText3: this.$t('apDataProcessingAppText3'),
				apDataTransferTitle: this.$t('apDataTransferTitle'),
				apDataTransferText1: this.$t('apDataTransferText1'),
				apDataTransferRegistrationTitle: this.$t('apDataTransferRegistrationTitle'),
				apDataTransferRegistrationText1: this.$t('apDataTransferRegistrationText1'),
				apDataTransferRegistrationText2: this.$t('apDataTransferRegistrationText2'),
				apDataTransferAuthoritiesTitle: this.$t('apDataTransferAuthoritiesTitle'),
				apDataTransferAuthoritiesText1: this.$t('apDataTransferAuthoritiesText1'),
				apDataTransferAuthoritiesText2: this.$t('apDataTransferAuthoritiesText2'),
				apDataTransferAuthoritiesList1: this.$t('apDataTransferAuthoritiesList1'),
				apDataTransferAuthoritiesList2: this.$t('apDataTransferAuthoritiesList2'),
				apDataTransferDependenciesTitle: this.$t('apDataTransferDependenciesTitle'),
				apDataTransferDependenciesText1: this.$t('apDataTransferDependenciesText1'),
				apThirdCountriesTitle: this.$t('apThirdCountriesTitle'),
				apThirdCountriesText1: this.$t('apThirdCountriesText1'),
				apChangeOfPurposeTitle: this.$t('apChangeOfPurposeTitle'),
				apChangeOfPurposeText1: this.$t('apChangeOfPurposeText1'),
				apDataStoragePeriodTitle: this.$t('apDataStoragePeriodTitle'),
				apDataStoragePeriodText1: this.$t('apDataStoragePeriodText1'),
				apYourRightsTitle: this.$t('apYourRightsTitle'),
				apYourRightsInformationTitle: this.$t('apYourRightsInformationTitle'),
				apYourRightsInformationText1: this.$t('apYourRightsInformationText1'),
				apYourRightsCorrectionTitle: this.$t('apYourRightsCorrectionTitle'),
				apYourRightsCorrectionText1: this.$t('apYourRightsCorrectionText1'),
				apYourRightsDeletionTitle: this.$t('apYourRightsDeletionTitle'),
				apYourRightsDeletionText1: this.$t('apYourRightsDeletionText1'),
				apYourRightsRestrictionTitle: this.$t('apYourRightsRestrictionTitle'),
				apYourRightsRestrictionText1: this.$t('apYourRightsRestrictionText1'),
				apYourRightsPortabilityTitle: this.$t('apYourRightsPortabilityTitle'),
				apYourRightsPortabilityText1: this.$t('apYourRightsPortabilityText1'),
				apObjectionTitle: this.$t('apObjectionTitle'),
				apObjectionText1: this.$t('apObjectionText1'),
				apAppealTitle: this.$t('apAppealTitle'),
				apAppealText1: this.$t('apAppealText1'),
				apAppealText2: this.$t('apAppealText2'),
				apContactTitle: this.$t('apContactTitle'),
				apContactText1: this.$t('apContactText1'),
				apContactText2: this.$t('apContactText2'),
				apContactText3: this.$t('apContactText3'),
				apChangesTitle: this.$t('apChangesTitle'),
				apChangesText1: this.$t('apChangesText1'),
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
		toHome() {
			this.$router.push({
				name: 'Home',
			});
		},
	},
};
</script>

<style scoped>
.ap-wrap-site {
	width: 100%;
	padding: 0px;
	margin: 0px;
	overflow-y: auto;
	position: relative;
	overflow-x: hidden;
}

.ap-wrap-site img {
	width: 300px;
	position: absolute;
	top: 5px;
	left: 5vw;
	cursor: pointer;
}

.ap-wrap-content {
	width: 100%;
	padding: 0% 5%;
	box-sizing: border-box;
}

.ap-footer {
	text-align: center;
}

h1 {
	margin: 40px auto 10px auto;
	width: fit-content;
	color: var(--main-color-text-light);
	position: relative;
	font-weight: normal;
	z-index: 0;
	font-size: 50px;
}
h2,
h3 {
	font-weight: normal;
	border-bottom: 1px solid var(--main-color-text-light);
	width: fit-content;
	padding: 10px 15px 5px 0px;
}

h2 {
	color: var(--main-color-highlight);
}

h3 {
	color: var(--secondary-color-highlight);
}

p {
	font-size: 20px;
	color: #ddd;
}

::v-deep a {
	color: var(--secondary-color-highlight);
}

::v-deep a:visited {
	color: #ccc491;
}

li {
	font-size: 20px;
	color: #ddd;
}

@media screen and (max-width: 1815px) {
	.ap-wrap-site img {
		width: 200px;
		position: static;
		display: block;
		margin: 10px auto;
	}

	.ap-wrap-site h1 {
		width: 90vw;
		margin: 10px 5vw 0px 5vw;
		text-align: center;
	}
}

@media (pointer: none), (pointer: coarse) {
	.ap-wrap-site h1 {
		font-size: 25px;
	}
}
</style>
